import React from 'react';
import { GetUserFullName, getEmptyValue, getApiDTNZFormat } from 'helpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openConfirmation } from 'helpers/Confirmation';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import { saveStrataData } from 'actions/protocols/protocoldetail';
import { TE, httpStatusEnum } from 'appconstants';
import { GridTable, GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { withChangeHandlers } from 'helpers/Change';
import { openSnackbar } from 'helpers/Notifier';
import {
  TableRow, TableCell, ListItem, ListItemText
} from '@material-ui/core';
import _ from 'lodash';
import { bindLogger } from 'helpers/BindLogger';
import { ValidatorForm,  MUISelect, MUITextBox } from 'components/FormHelpers/FormInputs';
import { StrataColumns } from '../gridcolumns';

  const RenderEditRow = ({ state, handleChange, cancel, reset, loadStatusRecords, data, cohort }) => {
    const {
      stratumName,
      status,
      statusReason,
      statusDate,
      targetAccrual,
      description,
      currentAccrual
    } = state;

    return (
      <TableRow className="state">
        <TableCell>{stratumName}</TableCell>
        <TableCell>{description}</TableCell>
        <TableCell>
          <MUISelect
            value={getEmptyValue(status)}
            name="status"
            onChange={handleChange}
            title="Status"
          >
            {_.map(loadStatusRecords(cohort.status), (item, i) => (
              <ListItem
                button
                key={_.uniqueId('status_sel')}
                value={item.value}
              >
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
          </MUISelect>
        </TableCell>
        <TableCell>
          <MUITextBox
            title="Status Reason"
            value={getEmptyValue(statusReason)}
            onChange={handleChange}
            validators={[]}
            errorMessages={[]}
            name="statusReason"
          />
        </TableCell>
        <TableCell>{statusDate}</TableCell>
        <TableCell>
          <MUITextBox
            title="Target Accrual"
            value={getEmptyValue(targetAccrual)}
            onChange={handleChange}
            validators={['matchRegexp:^[0-9]+$']}
            errorMessages={['Please enter numeric value']}
            name="targetAccrual"
          />
        </TableCell>
        <TableCell>{currentAccrual}</TableCell>
        <TableCell align='center'>
          <GridSubmitAction
            cancel={cancel}
            reset={reset}
          />
        </TableCell>
      </TableRow>
    );
  };
  const EditStrata = withAppContext(withChangeHandlers(RenderEditRow));

  let setEditingStrataFlag;

const StrataGrid = props => {

    const {
        data,
        CanUserEditStrata,
        highlightObj, 
        setHighlighted,
        onLoad, 
        rowClick,
        prtInfo,
        handleHistory, 
        context, 
        state, setState, 
        saveStrata, 
        cohort,
        loadStatusRecords
      } = props;

    const renderEdit = (row, setEditing) => {
      if (_.isEmpty(state) && !_.isEqual(row, state)) {
        setState({ ...row });
      }
  
      setEditingStrataFlag = (flg) => {
        setEditing(flg);
        setState({});
      };
  
      return (
        <EditStrata
          state={state || row}
          setEditing={setEditing}
          setState={setState}
          data={row}
          cohort={cohort}
          context={context}
          prtId={prtInfo.prtId}
          loadStatusRecords={loadStatusRecords}
        />
      );
    };
    const handleSave = () => {
        saveStrata(state, cohort);
      };

    return (
    <ValidatorForm onSubmit={handleSave}>
    <GridTable
        tag={`${TE.ID}strata${TE.TABLE}`}
        title={`Strata for Cohort ${cohort.cohortName || ''}`}
        id="StrataDataGrid"
        rows={data}
        rowEvents={[handleHistory]}
        rowEditable={(row) => CanUserEditStrata}
        editable={CanUserEditStrata}
        editMode={CanUserEditStrata}
        renderEditRow={renderEdit}
        columns={StrataColumns}
        user={GetUserFullName()}
        recordPerPage={5}
        enableToolbar
        onDataLoad={onLoad}
        highlightRowObject={highlightObj}
        onFilter={(object, field) => {
          setHighlighted(field);
        }}
        exportable={false}
        onRowClicked={rowClick}
        toPdf={false}
      />
        </ValidatorForm>
    );
};

const withConnectState = connect(
    state => {
      return {
        prtInfo: state.prtDetails.prtInfo
      };
    },
    dispatch => bindActionCreators({
      onSaveStrata: saveStrataData
    }, dispatch)
  );
  const Strata = compose(
    withAppContext,
    withConnectState,
    withState('state', 'setState', {}),
    withHandlers({
      saveStrata: props => (postBody, cohort) => {
        const {
            onSaveStrata, context, prtInfo
        } = props;
      const statusDate = getApiDTNZFormat(postBody.statusDate);

        const confirmSaveStrata = () => {
          bindLogger(onSaveStrata, context)(prtInfo.prtId, cohort.pmcId, {...postBody, statusDate})
            .subscribe(resp => {
              if (resp.status === httpStatusEnum.SUCCESS) {
                setEditingStrataFlag(false);
                openSnackbar({
                  message: 'Strata saved successfully.', 
                  variant: 'success',
                  name: 'versions'
                });
              }
            });
        };
        openConfirmation({
          message:  'Do you want to save strata record?',       
          onAction: confirmSaveStrata,
          name: 'strata'
        });
      },
      deleteStrata: props => verId => {
        setEditingStrataFlag(false);
      }
    }),
    withHandlers({
      handleHistory: ({loadHistory, onOpenModal, cohort}) => (evt,row) => {
        onOpenModal({
          type: 'StrataHistory',
          title: `Stratum Change History -Cohort ${cohort.cohortName},Stratum ${row.stratumName} `,
          data: null
        });
        loadHistory(evt, row.pmsId);
      }
    })
  )(StrataGrid);
  export {Strata};